<template>
    <div class="contacts-groups">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Grupos</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Submenu -->
                <mu-submenu :submenu="submenu"></mu-submenu>
            </mu-col>
        </mu-row>

        <!-- Listagem de grupos -->
        <div class="groups" v-if="!groups.loading">
            <div v-if="groups.paging.total > 0">

                <!-- Lista de grupos desktop -->
                <mu-group-card v-for="(item, key) in groups.list" :key="key" :item="item"></mu-group-card>

                <!-- Paginação -->
                <mu-flex class="paginate" justify-content="center" v-if="groups.paging.total > groups.paging.size">
                    <mu-pagination :total="groups.paging.total" :page-count="5" :page-size="groups.paging.size" :current.sync="groups.paging.page" @change="load()"></mu-pagination>
                </mu-flex>
            </div>
            <div class="data-empty" v-else>
                <mu-empty icon="/svg/menu/groups.svg" title="Nenhum grupo foi encontrado" subtitle="Crie agora mesmo seu primeiro grupo e organize seus contatos."></mu-empty>
            </div>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de grupos" v-if="groups.loading"></mu-loading>

    </div>
</template>

<script>
    import GroupsServices from '@/services/contacts/groups'

    export default {
        name: 'app-contacts-groups-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Grupos',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Grupo',
                        icon: 'plus',
                        route: 'app.contacts.groups.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                groups: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Grupo', name: 'name' },
                        { title: 'Compartilhado', name: 'shared' },
                        { title: 'Contatos', name: 'contacts', align: 'center' },
                        { title: 'Status', name: 'status', align: 'center' },
                        { title: '', name: 'edit' }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de grupos assim que
         * o componente é montado
         */
        created () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Quando clicado sobre o item é chamado essa função que redireciona para
             * a pagina de edição do item
             */
            edit (index, row, event) {
                if (!row.iseditable) {
                    this.$eventHub.$emit('snackbar', 'error', 'Você não pode editar um grupo compartilhado por outra empresa.', false)
                    return
                }
                this.$router.push({ name: 'app.contacts.groups.edit', params: { id: row.id } }).catch(err => { if (err) console.log(err.name || '') })
            },

            /**
             * Carrega a lista de grupos passando a paginação
             */
            async load () {
                try {
                    this.groups.loading = true
                    let result = await GroupsServices.findAll({
                        page: this.groups.paging.page
                    })
                    if (result && result.status) {
                        this.groups.paging.page = result.currentPage
                        this.groups.paging.total = result.rowCount
                        this.groups.list = result.results
                        return
                    }
                    this.$eventHub.$emit('snackbar', 'error', result.message, false)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.groups.loading = false
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .groups
        margin 20px 0

        .mu-list
            padding 0

        a
            color inherit
            text-decoration underline

        tr.mu-table-expand-row
            height: 0 !important

        .importing
            .text
                font-size 11px
                text-transform uppercase
                color $primary
                padding-left 10px

        .paginate
            padding 20px

        .mu-paper
            padding 0px

</style>
